/*******************************************************************************
* Project: SMTM_EXM
* Summary:
*    Define FullDateFormatPipe Pipe
* History:
*    NguyenTV            2021/07/02    Create Date format pipe
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
@Pipe({ name: 'dateFormatLanguage', pure: false })
export class DateFormatLanguagePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {
    }
    transform(pStrDate: string, pIsWeekday = false, pFormat: string = 'yyyy/MM/dd'): string {
        try {
            if (pStrDate !== undefined && pStrDate != null && pStrDate !== '' && pStrDate.trim() !== '') {
                const yyyy = Number(pStrDate.substring(0, 4));
                const MM = Number(pStrDate.substring(4, 6)) - 1;
                const dd = Number(pStrDate.substring(6, 8));
                const date = new Date(yyyy, MM, dd);
                switch (this.translateService.currentLang) {
                    case 'ja':
                        pFormat = 'yyyy年M月d日';
                        break;
                    case 'en':
                        pFormat = 'yyyy/MM/dd';
                        break;
                    case 'vi':
                        pFormat = 'dd/MM/yyyy';
                        break;
                    default:
                        break;
                }
                return new DatePipe('en-US').transform(date, pFormat) + (pIsWeekday ? ' (' + this.getDayName(date) + ')' : '');
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    }
    getDayName(dateStr) {
        const intWeekday = new Date(dateStr).getDay();
        let strWeekday;
        switch (intWeekday) {
            case 0:
                strWeekday = this.translateService.instant('STR_SUNDAY');
                break;
            case 1:
                strWeekday = this.translateService.instant('STR_MONDAY');
                break;
            case 2:
                strWeekday = this.translateService.instant('STR_TUESDAY');
                break;
            case 3:
                strWeekday = this.translateService.instant('STR_WEDNESDAY');
                break;
            case 4:
                strWeekday = this.translateService.instant('STR_THURSDAY');
                break;
            case 5:
                strWeekday = this.translateService.instant('STR_FRIDAY');
                break;
            case 6:
                strWeekday = this.translateService.instant('STR_SATURDAY');
                break;
            default:
                strWeekday = null;
                break;
        }
        return strWeekday;
    }
}
